import React, { useState, memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import AuthAction from "../../store/auth/authAction";
import LoginForm from "./LoginForm";
import * as Styled from "./styled";
import moment from "moment";
import {EXT_TITLE, VERSION} from "../../config/consts";
import LogoIcon from "../../components/UI/Icons/LogoIcon";
import config from "../../config/config";

export default memo(() => {
  const [state, setState] = useState({
    username: null,
    password: null,
  });

  const dispatch = useDispatch();
  const loginInit = useCallback(
    (username, password) => dispatch(AuthAction.loginInit(username, password)),
    [dispatch]
  );

  const onLogin = () => {
    loginInit(state.username, state.password);
    return false;
  };

  const onInputChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };


  return (
    <>
      <Styled.Outer>
        <Styled.LoginLogo>
          {/*<Styled.LoginLogoText1>Webint</Styled.LoginLogoText1>
          <Styled.LoginLogoText2>Center</Styled.LoginLogoText2>&nbsp;*/}
          <LogoIcon
            type={config.headerLogo}
            title={`${config.appTitle || EXT_TITLE} ${VERSION}`}
            style={{maxHeight: '56px'}}
          />
          <Styled.LoginLogoText2>{VERSION}</Styled.LoginLogoText2>
        </Styled.LoginLogo>
        <Styled.LoginContainer>
          <LoginForm
            values={state}
            onLogin={onLogin}
            onInputChange={onInputChange}
            isSubmitDisabled={!state.username || !state.password}
          />
        </Styled.LoginContainer>
      </Styled.Outer>
    </>
  );
});
